import { render } from "./ListLoader.vue?vue&type=template&id=450c08e1&ts=true"
import script from "./ListLoader.vue?vue&type=script&lang=ts"
export * from "./ListLoader.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Work\\Picado\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__